export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AppToolbar.vue?vue&type=template&id=2ffc1fd5&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/core/AppToolbar.vue?vue&type=template&id=2ffc1fd5&scoped=true&
// module id = 169
// module chunks = 32